/* Styles */
import "@/scss/main.scss";
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css"; // 引入视频样式
import "vue-video-player/src/custom-theme.css"; // 引入vue-video-player样式
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
/* Core */
import Vue from "vue";
import Buefy from "buefy";
// import 'buefy/dist/buefy.css'
/* Router & Store */
import router from "./router";
import store from "./store";
import { parseTime } from "@/utils/custom";
/* Vue. Main component */
import App from "./App.vue";
import { getToken } from "@/utils/auth"; // get token from cookie'

import "@/css/public.css"; // 公共样式

import APlayer from "@moefe/vue-aplayer";
Vue.prototype.parseTime = parseTime;
Vue.use(APlayer, {
  defaultCover: "https://github.com/u3u.png",
  productionTip: true,
});

import { formatTimestamp } from "@/utils/day.js";

Vue.prototype.$dayjs = {
  format: formatTimestamp,
};

/* Fetch sample data */
// store.dispatch('fetch', 'clients')

/* Default title tag */
const defaultDocumentTitle = "超声在线";

// 设置cookie,增加到vue实例方便全局调用
// vue全局调用的理由是，有些组件所用到的接口可能需要session验证，session从cookie获取
// 当然，如果session保存到vuex的话除外
Vue.prototype.setCookie = (cookieName, value, expiredays) => {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    cookieName +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
};

// 获取cookie、
function getCookie(name) {
  let arr;
  const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr === document.cookie.match(reg)) {
    return arr[2];
  } else {
    return null;
  }
}
Vue.prototype.getCookie = getCookie;
Vue.prototype.getToken = getToken;

/* Collapse mobile aside menu on route change & set document title from route meta */
router.afterEach((to) => {
  store.commit("asideMobileStateToggle", false);
  store.dispatch("asideDesktopOnlyToggle", false);

  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} — ${defaultDocumentTitle}`;
  } else {
    document.title = defaultDocumentTitle;
  }
});

router.beforeEach((to, from, next) => {
  const hasToken = store.getters.getUserToken;
  console.log(111, hasToken)
  if (!hasToken && to.meta.needLogin) {
    console.log("notoken", to.fullPath);
    sessionStorage.setItem("attemptedURL", to.fullPath);
    next("/401");
  } else {
    next();
  }

  // if (!hasToken && to.path !== '/login') {
  //   // 用户未登录，且试图访问非登录页面
  //   next('/401') // 重定向到登录提示页面
  // } else {
  //   next() // 否则正常导航到路由
  // }
});

Vue.config.productionTip = false;
Vue.use(VueViewer);
Vue.use(VueVideoPlayer);
Vue.use(Buefy);

store.dispatch('restoreUserName').catch(() => {})

new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate () {
    Vue.prototype.$bus = this;
  }
}).$mount("#app");
